import React from 'react';

/**
 * Hero for the unified pricing surface. Reviews and Writer are one product:
 * you draft in the editor and hand the draft to a referee whenever you like.
 */
export const PricingHeaderV2 = () => {
  return (
    <div className="text-center mb-10">
      <h1 className="text-3xl md:text-4xl font-bold mb-4">
        Write Your Paper, Checked as You Go
      </h1>
      <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
        Draft in PaperVerse and let an AI reviewer read the manuscript whenever you want —
        one balance covers the writing and the checks.
        <span className="block text-sm mt-2 text-muted-foreground/80">
          Reviews on public arXiv papers are always free.
        </span>
      </p>
    </div>

  );
};

export default PricingHeaderV2;
